module.exports = __webpack_public_path__ + "68b4f70bb3a9d34c4dcd262d4e6819c6.MP3";